var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"disabled":_vm.disabled || !_vm.content,"top":_vm.top,"right":_vm.right,"bottom":_vm.bottom,"left":_vm.left,"nudge-top":_vm.nudgeTop,"nudge-right":_vm.nudgeRight,"nudge-bottom":_vm.nudgeBottom,"nudge-left":_vm.nudgeLeft,"activator":_vm.activator}},[_c('span',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }